var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactGraphic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 663 255",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "contact-graphic_svg__a",
    d: "M.362 0L0 254h651.637L652 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "contact-graphic_svg__c",
    d: "M.362 0L0 254h651.637L652 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "contact-graphic_svg__e",
    d: "M.362 0L0 254h651.637L652 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "contact-graphic_svg__g",
    d: "M.362 0L0 254h651.637L652 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "contact-graphic_svg__i",
    d: "M.362 0L0 254h651.637L652 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "contact-graphic_svg__k",
    d: "M.362 0L0 254h651.637L652 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "contact-graphic_svg__m",
    d: "M.362 0L0 254h651.637L652 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "contact-graphic_svg__o",
    d: "M.362 0L0 254h651.637L652 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "contact-graphic_svg__q",
    d: "M.362 0L0 254h651.637L652 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "contact-graphic_svg__s",
    d: "M.362 0L0 254h651.637L652 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "contact-graphic_svg__u",
    d: "M.362 0L0 254h651.637L652 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "contact-graphic_svg__w",
    d: "M.362 0L0 254h651.637L652 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "contact-graphic_svg__y",
    d: "M.362 0L0 254h651.637L652 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "contact-graphic_svg__A",
    d: "M.362 0L0 254h651.637L652 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "contact-graphic_svg__C",
    d: "M.362 0L0 254h651.637L652 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "contact-graphic_svg__E",
    d: "M.362 0L0 254h651.637L652 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "contact-graphic_svg__G",
    d: "M.362 0L0 254h651.637L652 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "contact-graphic_svg__I",
    d: "M.362 0L0 254h651.637L652 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "contact-graphic_svg__K",
    d: "M.362 0L0 254h651.637L652 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "contact-graphic_svg__M",
    d: "M.362 0L0 254h651.637L652 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "contact-graphic_svg__O",
    d: "M.362 0L0 254h651.637L652 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "contact-graphic_svg__Q",
    d: "M.362 0L0 254h651.637L652 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "contact-graphic_svg__S",
    d: "M.362 0L0 254h651.637L652 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "contact-graphic_svg__U",
    d: "M.362 0L0 254h651.637L652 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "contact-graphic_svg__W",
    d: "M.362 0L0 254h651.637L652 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "contact-graphic_svg__Y",
    d: "M.362 0L0 254h651.637L652 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "contact-graphic_svg__aa",
    d: "M.362 0L0 254h651.637L652 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "contact-graphic_svg__ac",
    d: "M.362 0L0 254h651.637L652 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "contact-graphic_svg__ae",
    d: "M.362 0L0 254h651.637L652 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "contact-graphic_svg__ag",
    d: "M.362 0L0 254h651.637L652 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "contact-graphic_svg__ai",
    d: "M.362 0L0 254h651.637L652 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "contact-graphic_svg__ak",
    d: "M.362 0L0 254h651.637L652 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "contact-graphic_svg__am",
    d: "M.362 0L0 254h651.637L652 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "contact-graphic_svg__ao",
    d: "M.362 0L0 254h651.637L652 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "contact-graphic_svg__aq",
    d: "M.362 0L0 254h651.637L652 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "contact-graphic_svg__as",
    d: "M.362 0L0 254h651.637L652 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "contact-graphic_svg__au",
    d: "M.362 0L0 254h651.637L652 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "contact-graphic_svg__aw",
    d: "M.362 0L0 254h651.637L652 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "contact-graphic_svg__ay",
    d: "M.362 0L0 254h651.637L652 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "contact-graphic_svg__aA",
    d: "M.362 0L0 254h651.637L652 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "contact-graphic_svg__aC",
    d: "M.362 0L0 254h651.637L652 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "contact-graphic_svg__aE",
    d: "M.362 0L0 254h651.637L652 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "contact-graphic_svg__aG",
    d: "M.362 0L0 254h651.637L652 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "contact-graphic_svg__aI",
    d: "M.362 0L0 254h651.637L652 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "contact-graphic_svg__aK",
    d: "M.362 0L0 254h651.637L652 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "contact-graphic_svg__aM",
    d: "M.362 0L0 254h651.637L652 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "contact-graphic_svg__aO",
    d: "M.362 0L0 254h651.637L652 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "contact-graphic_svg__aQ",
    d: "M.362 0L0 254h651.637L652 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "contact-graphic_svg__aS",
    d: "M.362 0L0 254h651.637L652 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "contact-graphic_svg__aU",
    d: "M.362 0L0 254h651.637L652 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "contact-graphic_svg__aW",
    d: "M.362 0L0 254h651.637L652 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "contact-graphic_svg__aY",
    d: "M0 313h663V0H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 3)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "contact-graphic_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#contact-graphic_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M610.943 179.592c0 6.916-5.6 12.517-12.513 12.517H443.292c-6.909 0-12.511-5.601-12.511-12.517v-36.297c0-6.914 5.602-12.518 12.511-12.518H598.43c6.912 0 12.513 5.604 12.513 12.518v36.297z",
    fill: "#666",
    mask: "url(#contact-graphic_svg__b)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "contact-graphic_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#contact-graphic_svg__c"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M610.943 179.592c0 6.916-5.6 12.517-12.513 12.517H443.292c-6.909 0-12.511-5.601-12.511-12.517v-36.297c0-6.914 5.602-12.518 12.511-12.518H598.43c6.912 0 12.513 5.604 12.513 12.518v36.297z",
    stroke: "#353535",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__d)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "contact-graphic_svg__f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#contact-graphic_svg__e"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    mask: "url(#contact-graphic_svg__f)",
    d: "M588.768 209.434v-83.673l-35.836-35.858h-99.976V209.434z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "contact-graphic_svg__h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#contact-graphic_svg__g"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#353535",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__h)",
    d: "M588.768 209.434v-83.673l-35.836-35.858h-99.976V209.434z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "contact-graphic_svg__j",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#contact-graphic_svg__i"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    mask: "url(#contact-graphic_svg__j)",
    d: "M587.728 125.76h-34.796l34.796 34.808z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "contact-graphic_svg__l",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#contact-graphic_svg__k"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#EE4900",
    mask: "url(#contact-graphic_svg__l)",
    d: "M552.932 125.76h35.836l-35.836-35.857z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "contact-graphic_svg__n",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#contact-graphic_svg__m"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#353535",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#contact-graphic_svg__n)",
    d: "M552.932 125.76h35.836l-35.836-35.857z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "contact-graphic_svg__p",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#contact-graphic_svg__o"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M628.886 248.018a2.504 2.504 0 01-2.502 2.503H415.34a2.503 2.503 0 01-2.501-2.503v-76.77a2.504 2.504 0 012.501-2.504h211.045a2.505 2.505 0 012.502 2.503v76.77z",
    fill: "#666",
    mask: "url(#contact-graphic_svg__p)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "contact-graphic_svg__r",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#contact-graphic_svg__q"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M628.886 248.018a2.504 2.504 0 01-2.502 2.503H415.34a2.503 2.503 0 01-2.501-2.503v-76.77a2.504 2.504 0 012.501-2.504h211.045a2.505 2.505 0 012.502 2.503v76.77z",
    stroke: "#353535",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__r)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "contact-graphic_svg__t",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#contact-graphic_svg__s"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M623.88 248.018c0 1.384-1.07 2.503-2.388 2.503h-201.26c-1.319 0-2.387-1.12-2.387-2.503v-76.77c0-1.383 1.068-2.504 2.387-2.504h201.26c1.318 0 2.389 1.12 2.389 2.503v76.77z",
    fill: "#999",
    mask: "url(#contact-graphic_svg__t)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "contact-graphic_svg__v",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#contact-graphic_svg__u"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M623.88 248.018c0 1.384-1.07 2.503-2.388 2.503h-201.26c-1.319 0-2.387-1.12-2.387-2.503v-76.77c0-1.383 1.068-2.504 2.387-2.504h201.26c1.318 0 2.389 1.12 2.389 2.503v76.77z",
    stroke: "#353535",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__v)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "contact-graphic_svg__x",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#contact-graphic_svg__w"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M607.093 211.3H433.282a2.503 2.503 0 00-2.501 2.504v36.717h178.816v-36.717a2.504 2.504 0 00-2.504-2.504",
    fill: "#666",
    mask: "url(#contact-graphic_svg__x)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "contact-graphic_svg__z",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#contact-graphic_svg__y"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M607.093 211.3H433.282a2.503 2.503 0 00-2.501 2.504v36.717h178.816v-36.717a2.504 2.504 0 00-2.504-2.504z",
    stroke: "#353535",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__z)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "contact-graphic_svg__B",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#contact-graphic_svg__A"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M535.547 183.347h-30.714c-.244 0-.44.084-.44.19v3.15h31.594v-3.15c0-.106-.198-.19-.44-.19",
    fill: "#CCC",
    mask: "url(#contact-graphic_svg__B)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "contact-graphic_svg__D",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#contact-graphic_svg__C"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M535.547 183.347h-30.714c-.244 0-.44.084-.44.19v3.15h31.594v-3.15c0-.106-.198-.19-.44-.19z",
    stroke: "#353535",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__D)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "contact-graphic_svg__F",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#contact-graphic_svg__E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M430.954 249.18l-14.525 24.218c0 1.604 1.3 2.908 2.905 2.908h201.78c1.6 0 2.907-1.304 2.907-2.908l-14.527-24.219h-178.54z",
    fill: "#30363D",
    mask: "url(#contact-graphic_svg__F)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "contact-graphic_svg__H",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#contact-graphic_svg__G"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M430.954 249.18l-14.525 24.218c0 1.604 1.3 2.908 2.905 2.908h201.78c1.6 0 2.907-1.304 2.907-2.908l-14.527-24.219h-178.54z",
    stroke: "#368CB2",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__H)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "contact-graphic_svg__J",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#contact-graphic_svg__I"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M430.954 249.18l-14.525 24.218c0 1.604 1.3 2.908 2.905 2.908h201.78c1.6 0 2.907-1.304 2.907-2.908l-14.527-24.219h-178.54z",
    fill: "#CCC",
    mask: "url(#contact-graphic_svg__J)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "contact-graphic_svg__L",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#contact-graphic_svg__K"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M430.954 249.18l-14.525 24.218c0 1.604 1.3 2.908 2.905 2.908h201.78c1.6 0 2.907-1.304 2.907-2.908l-14.527-24.219h-178.54z",
    stroke: "#353535",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__L)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "contact-graphic_svg__N",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#contact-graphic_svg__M"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#EFEFEF",
    mask: "url(#contact-graphic_svg__N)",
    d: "M436.283 269.213l17.745-32.46 132.214-.418 17.921 32.878z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "contact-graphic_svg__P",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#contact-graphic_svg__O"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#353535",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__P)",
    d: "M436.283 269.213l17.745-32.46 132.214-.418 17.921 32.878z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "contact-graphic_svg__R",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#contact-graphic_svg__Q"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M435.785 185.85a2.503 2.503 0 11-5.006 0 2.503 2.503 0 015.006 0",
    fill: "#41A9D8",
    mask: "url(#contact-graphic_svg__R)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "contact-graphic_svg__T",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#contact-graphic_svg__S"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M435.785 185.85a2.503 2.503 0 11-5.006 0 2.503 2.503 0 015.006 0z",
    stroke: "#368CB2",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__T)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "contact-graphic_svg__V",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#contact-graphic_svg__U"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M600.838 185.85a2.503 2.503 0 11-5.006.001 2.503 2.503 0 015.006 0",
    fill: "#EE4900",
    mask: "url(#contact-graphic_svg__V)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "contact-graphic_svg__X",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#contact-graphic_svg__W"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M600.838 185.85a2.503 2.503 0 11-5.006.001 2.503 2.503 0 015.006 0z",
    stroke: "#353535",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__X)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "contact-graphic_svg__Z",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#contact-graphic_svg__Y"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M609.597 185.85a2.503 2.503 0 11-5.006.002 2.503 2.503 0 015.006-.002",
    fill: "#EFEFEF",
    mask: "url(#contact-graphic_svg__Z)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "contact-graphic_svg__ab",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#contact-graphic_svg__aa"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M609.597 185.85a2.503 2.503 0 11-5.006.002 2.503 2.503 0 015.006-.002z",
    stroke: "#353535",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__ab)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "contact-graphic_svg__ad",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#contact-graphic_svg__ac"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M80.249 270.841c-3.55.015-4.263 4.017-4.263 4.017a.838.838 0 01-.005-.152c-.008.227-2.506 22.642-35.282 24.9-8.256.567-13.68-2.177-16.589-8.39-6.326-13.524.42-40.592 14.162-56.794 7.587-8.946 25.282-20.18 37.821-27.531l-.441-12.059c-12.94 7.372-35.452 21.1-45.08 32.444-7.565 8.926-13.71 21.285-16.859 33.903-3.388 13.59-2.977 25.941 1.159 34.77 4.6 9.823 13.576 14.926 25.368 14.456.373-.012.753-.032 1.134-.056 11.186-.77 26.659-4.31 36.865-16.793 6.079-7.441 8.149-15.67 8.025-19.105 0 0-1.114-3.63-6.015-3.61",
    fill: "#41A9D8",
    mask: "url(#contact-graphic_svg__ad)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "contact-graphic_svg__af",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#contact-graphic_svg__ae"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M80.249 270.841c-3.55.015-4.263 4.017-4.263 4.017a.838.838 0 01-.005-.152c-.008.227-2.506 22.642-35.282 24.9-8.256.567-13.68-2.177-16.589-8.39-6.326-13.524.42-40.592 14.162-56.794 7.587-8.946 25.282-20.18 37.821-27.531l-.441-12.059c-12.94 7.372-35.452 21.1-45.08 32.444-7.565 8.926-13.71 21.285-16.859 33.903-3.388 13.59-2.977 25.941 1.159 34.77 4.6 9.823 13.576 14.926 25.368 14.456.373-.012.753-.032 1.134-.056 11.186-.77 26.659-4.31 36.865-16.793 6.079-7.441 8.149-15.67 8.025-19.105 0 0-1.114-3.63-6.015-3.61z",
    stroke: "#368CB2",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__af)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "contact-graphic_svg__ah",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#contact-graphic_svg__ag"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M80.249 270.841c-3.55.015-4.263 4.017-4.263 4.017a.838.838 0 01-.005-.152c-.008.227-2.506 22.642-35.282 24.9-8.256.567-13.68-2.177-16.589-8.39-6.326-13.524.42-40.592 14.162-56.794 7.587-8.946 25.282-20.18 37.821-27.531l-.441-12.059c-12.94 7.372-35.452 21.1-45.08 32.444-7.565 8.926-13.71 21.285-16.859 33.903-3.388 13.59-2.977 25.941 1.159 34.77 4.6 9.823 13.576 14.926 25.368 14.456.373-.012.753-.032 1.134-.056 11.186-.77 26.659-4.31 36.865-16.793 6.079-7.441 8.149-15.67 8.025-19.105 0 0-1.114-3.63-6.015-3.61",
    fill: "#333",
    mask: "url(#contact-graphic_svg__ah)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "contact-graphic_svg__aj",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#contact-graphic_svg__ai"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M80.249 270.841c-3.55.015-4.263 4.017-4.263 4.017a.838.838 0 01-.005-.152c-.008.227-2.506 22.642-35.282 24.9-8.256.567-13.68-2.177-16.589-8.39-6.326-13.524.42-40.592 14.162-56.794 7.587-8.946 25.282-20.18 37.821-27.531l-.441-12.059c-12.94 7.372-35.452 21.1-45.08 32.444-7.565 8.926-13.71 21.285-16.859 33.903-3.388 13.59-2.977 25.941 1.159 34.77 4.6 9.823 13.576 14.926 25.368 14.456.373-.012.753-.032 1.134-.056 11.186-.77 26.659-4.31 36.865-16.793 6.079-7.441 8.149-15.67 8.025-19.105 0 0-1.114-3.63-6.015-3.61z",
    stroke: "#353535",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__aj)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "contact-graphic_svg__al",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#contact-graphic_svg__ak"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M241.793 261.305c0 2.12-1.718 4.032-3.834 4.26a815.77 815.77 0 01-171.443 0c-2.116-.228-3.83-2.14-3.83-4.26v-113.04a3.844 3.844 0 013.842-3.847H237.95a3.848 3.848 0 013.843 3.847v113.04z",
    fill: "#666",
    mask: "url(#contact-graphic_svg__al)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "contact-graphic_svg__an",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#contact-graphic_svg__am"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M241.793 261.305c0 2.12-1.718 4.032-3.834 4.26a815.77 815.77 0 01-171.443 0c-2.116-.228-3.83-2.14-3.83-4.26v-113.04a3.844 3.844 0 013.842-3.847H237.95a3.848 3.848 0 013.843 3.847v113.04z",
    stroke: "#353535",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__an)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "contact-graphic_svg__ap",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#contact-graphic_svg__ao"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M65.732 259.827c-.832-.085-1.52-.835-1.52-1.673 0-37.147.006-74.297.006-111.444 0-.837.685-1.515 1.527-1.512 56.63.112 113.27.112 169.899 0a1.518 1.518 0 011.527 1.512c0 37.147 0 74.297.005 111.444 0 .838-.682 1.588-1.519 1.673a830.11 830.11 0 01-169.925 0",
    fill: "#666",
    mask: "url(#contact-graphic_svg__ap)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "contact-graphic_svg__ar",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#contact-graphic_svg__aq"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M65.732 259.827c-.832-.085-1.52-.835-1.52-1.673 0-37.147.006-74.297.006-111.444 0-.837.685-1.515 1.527-1.512 56.63.112 113.27.112 169.899 0a1.518 1.518 0 011.527 1.512c0 37.147 0 74.297.005 111.444 0 .838-.682 1.588-1.519 1.673a830.11 830.11 0 01-169.925 0z",
    stroke: "#353535",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__ar)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "contact-graphic_svg__at",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#contact-graphic_svg__as"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M115.26 146.778c0-.874-.473-1.583-1.051-1.58h-.535v119.896c.183-.025.36-.053.544-.078.574-.092 1.045-.878 1.045-1.75-.003-38.829-.003-77.659-.003-116.488",
    fill: "#666",
    mask: "url(#contact-graphic_svg__at)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "contact-graphic_svg__av",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#contact-graphic_svg__au"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M115.26 146.778c0-.874-.473-1.583-1.051-1.58h-.535v119.896c.183-.025.36-.053.544-.078.574-.092 1.045-.878 1.045-1.75-.003-38.829-.003-77.659-.003-116.488z",
    stroke: "#353535",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__av)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "contact-graphic_svg__ax",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#contact-graphic_svg__aw"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M89.315 252.043c-4.647 0-9.385-.457-14.08-1.358-1.967-.378-3.71-2.296-3.885-4.273a629.24 629.24 0 010-108.204c.18-1.976 1.922-3.891 3.883-4.273a74.79 74.79 0 0114.081-1.36c4.647 0 9.384.457 14.078 1.36 1.964.376 3.708 2.291 3.888 4.27a628.947 628.947 0 010 108.205c-.18 1.982-1.923 3.897-3.886 4.275a74.86 74.86 0 01-14.079 1.358",
    fill: "#666",
    mask: "url(#contact-graphic_svg__ax)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "contact-graphic_svg__az",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#contact-graphic_svg__ay"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M89.315 131.782c-4.697 0-9.485.463-14.23 1.375-2.325.452-4.31 2.637-4.524 4.976a630.007 630.007 0 000 108.345c.208 2.349 2.195 4.537 4.524 4.984a75.681 75.681 0 0014.23 1.373c4.697 0 9.484-.462 14.228-1.373 2.325-.446 4.313-2.631 4.526-4.976a629.856 629.856 0 00.001-108.347c-.215-2.351-2.204-4.537-4.53-4.982a75.529 75.529 0 00-14.225-1.375m-.001 1.585c4.631 0 9.261.448 13.928 1.346 1.647.315 3.102 1.949 3.25 3.563a626.367 626.367 0 010 108.066c-.148 1.617-1.603 3.25-3.247 3.564a73.647 73.647 0 01-13.93 1.345c-4.63 0-9.262-.449-13.93-1.345-1.643-.315-3.103-1.947-3.246-3.564a626.526 626.526 0 010-108.066c.146-1.614 1.606-3.244 3.245-3.563a73.54 73.54 0 0113.93-1.346",
    fill: "#353535",
    mask: "url(#contact-graphic_svg__az)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "contact-graphic_svg__aB",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#contact-graphic_svg__aA"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M106.475 246.502c-.139 1.561-1.59 3.144-3.233 3.452-9.329 1.731-18.524 1.731-27.852 0-1.645-.308-3.095-1.89-3.239-3.452a626.55 626.55 0 01-.314-104.573c.129-1.567 1.598-3.145 3.267-3.452 9.512-1.735 18.913-1.735 28.417 0 1.675.307 3.145 1.885 3.274 3.452a626.042 626.042 0 01-.32 104.573",
    fill: "#666",
    mask: "url(#contact-graphic_svg__aB)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "contact-graphic_svg__aD",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#contact-graphic_svg__aC"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M106.475 246.502c-.139 1.561-1.59 3.144-3.233 3.452-9.329 1.731-18.524 1.731-27.852 0-1.645-.308-3.095-1.89-3.239-3.452a626.55 626.55 0 01-.314-104.573c.129-1.567 1.598-3.145 3.267-3.452 9.512-1.735 18.913-1.735 28.417 0 1.675.307 3.145 1.885 3.274 3.452a626.042 626.042 0 01-.32 104.573z",
    stroke: "#353535",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__aD)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "contact-graphic_svg__aF",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#contact-graphic_svg__aE"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M89.316 246.966c-4.117 0-8.303-.417-12.442-1.239-1.775-.357-3.318-2.138-3.443-3.972a730.969 730.969 0 01-.025-98.5c.121-1.834 1.667-3.615 3.445-3.97a64.25 64.25 0 0112.463-1.24c4.125 0 8.32.418 12.466 1.24 1.778.355 3.323 2.136 3.445 3.97a730.968 730.968 0 01-.026 98.5c-.129 1.835-1.672 3.616-3.44 3.971a63.987 63.987 0 01-12.443 1.24",
    fill: "#666",
    mask: "url(#contact-graphic_svg__aF)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "contact-graphic_svg__aH",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#contact-graphic_svg__aG"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M89.314 137.254c-4.178 0-8.422.422-12.616 1.253-2.145.428-3.936 2.491-4.082 4.695a731.618 731.618 0 00.026 98.606c.149 2.204 1.938 4.266 4.074 4.695a64.785 64.785 0 0012.6 1.255c4.169 0 8.406-.421 12.597-1.255 2.133-.428 3.921-2.49 4.075-4.692a731.807 731.807 0 00.028-98.61c-.147-2.203-1.94-4.266-4.08-4.693a65.106 65.106 0 00-12.622-1.254m0 1.585c4.098 0 8.197.407 12.311 1.222 1.447.29 2.712 1.776 2.81 3.247a727.947 727.947 0 01-.027 98.393c-.103 1.474-1.362 2.959-2.804 3.249a62.891 62.891 0 01-12.288 1.224c-4.09 0-8.18-.408-12.288-1.224-1.443-.29-2.707-1.778-2.806-3.25a727.817 727.817 0 01-.026-98.392c.098-1.47 1.362-2.958 2.81-3.247a63.125 63.125 0 0112.307-1.222",
    fill: "#353535",
    mask: "url(#contact-graphic_svg__aH)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "contact-graphic_svg__aJ",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#contact-graphic_svg__aI"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M96.055 140.061a56.916 56.916 0 012.76-.49c-7.28-1.118-14.515-.956-21.81.49-1.446.29-2.712 1.776-2.81 3.247a731.15 731.15 0 00-1.62 56.144 78.652 78.652 0 0018.274-1.094c1.613-.292 2.912-1.782 2.912-3.255.005-1.645.086-3.288.231-4.924a2594.624 2594.624 0 00-.462-46.871c-.023-1.47 1.105-2.958 2.525-3.247",
    fill: "#999",
    mask: "url(#contact-graphic_svg__aJ)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "contact-graphic_svg__aL",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#contact-graphic_svg__aK"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M115.246 146.02c0-.88-.235-1.595-.52-1.592h-.273v120.666c.094-.025.183-.053.277-.078.285-.092.516-.883.516-1.762V146.02z",
    fill: "#666",
    mask: "url(#contact-graphic_svg__aL)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "contact-graphic_svg__aN",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#contact-graphic_svg__aM"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M115.246 146.02c0-.88-.235-1.595-.52-1.592h-.273v120.666c.094-.025.183-.053.277-.078.285-.092.516-.883.516-1.762V146.02z",
    stroke: "#353535",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__aN)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "contact-graphic_svg__aP",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#contact-graphic_svg__aO"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M229.174 206.729a3.854 3.854 0 01-3.846 3.848H127.7a3.853 3.853 0 01-3.842-3.848v-69.231c.004-2.12 1.706-4.141 3.82-4.485a306.212 306.212 0 0197.676 0c2.11.343 3.82 2.368 3.82 4.485v69.23z",
    fill: "#EFEFEF",
    mask: "url(#contact-graphic_svg__aP)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "contact-graphic_svg__aR",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#contact-graphic_svg__aQ"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M229.174 206.729a3.854 3.854 0 01-3.846 3.848H127.7a3.853 3.853 0 01-3.842-3.848v-69.231c.004-2.12 1.706-4.141 3.82-4.485a306.212 306.212 0 0197.676 0c2.11.343 3.82 2.368 3.82 4.485v69.23z",
    stroke: "#353535",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__aR)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "contact-graphic_svg__aT",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#contact-graphic_svg__aS"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M227.282 204.706a3.708 3.708 0 01-3.709 3.712h-94.118a3.707 3.707 0 01-3.704-3.712V138.73a3.706 3.706 0 013.704-3.704h94.118a3.707 3.707 0 013.709 3.704v65.977z",
    fill: "#F6FAFB",
    mask: "url(#contact-graphic_svg__aT)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "contact-graphic_svg__aV",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#contact-graphic_svg__aU"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M227.282 204.706a3.708 3.708 0 01-3.709 3.712h-94.118a3.707 3.707 0 01-3.704-3.712V138.73a3.706 3.706 0 013.704-3.704h94.118a3.707 3.707 0 013.709 3.704v65.977z",
    stroke: "#353535",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__aV)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "contact-graphic_svg__aX",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#contact-graphic_svg__aW"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    mask: "url(#contact-graphic_svg__aX)",
    d: "M133.658 191.585h84.051v-49.218h-84.05z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#353535",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__aX)",
    d: "M133.658 191.585h84.051v-49.218h-84.05z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    mask: "url(#contact-graphic_svg__aX)",
    d: "M174.65 143.782h-30.305l-9.15 23.166v23.735h20.937zM173.213 190.683l18.519-46.901h-11.57l-18.523 46.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.833 198.24c0 .807-.593 1.458-1.329 1.458h-9.264c-.732 0-1.324-.65-1.324-1.457 0-.806.592-1.458 1.324-1.458h9.264c.736 0 1.33.652 1.33 1.458",
    fill: "#666",
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.833 198.24c0 .807-.593 1.458-1.329 1.458h-9.264c-.732 0-1.324-.65-1.324-1.457 0-.806.592-1.458 1.324-1.458h9.264c.736 0 1.33.652 1.33 1.458z",
    stroke: "#353535",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.833 197.616c0 .804-.593 1.458-1.329 1.458h-9.264c-.732 0-1.324-.654-1.324-1.458 0-.806.592-1.459 1.324-1.459h9.264c.736 0 1.33.653 1.33 1.459",
    fill: "#F4A27F",
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.833 197.616c0 .804-.593 1.458-1.329 1.458h-9.264c-.732 0-1.324-.654-1.324-1.458 0-.806.592-1.459 1.324-1.459h9.264c.736 0 1.33.653 1.33 1.459z",
    stroke: "#353535",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.416 198.24c0 .807-.596 1.458-1.328 1.458h-9.265c-.73 0-1.322-.65-1.322-1.457 0-.806.592-1.458 1.322-1.458h9.265c.732 0 1.328.652 1.328 1.458",
    fill: "#41A9D8",
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.416 198.24c0 .807-.596 1.458-1.328 1.458h-9.265c-.73 0-1.322-.65-1.322-1.457 0-.806.592-1.458 1.322-1.458h9.265c.732 0 1.328.652 1.328 1.458z",
    stroke: "#353535",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.416 197.616c0 .804-.596 1.458-1.328 1.458h-9.265c-.73 0-1.322-.654-1.322-1.458 0-.806.592-1.459 1.322-1.459h9.265c.732 0 1.328.653 1.328 1.459",
    fill: "#F4A27F",
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.416 197.616c0 .804-.596 1.458-1.328 1.458h-9.265c-.73 0-1.322-.654-1.322-1.458 0-.806.592-1.459 1.322-1.459h9.265c.732 0 1.328.653 1.328 1.459z",
    stroke: "#353535",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181 198.24c0 .807-.593 1.458-1.322 1.458h-9.267c-.735 0-1.326-.65-1.326-1.457 0-.806.591-1.458 1.326-1.458h9.267c.73 0 1.322.652 1.322 1.458",
    fill: "#666",
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181 198.24c0 .807-.593 1.458-1.322 1.458h-9.267c-.735 0-1.326-.65-1.326-1.457 0-.806.591-1.458 1.326-1.458h9.267c.73 0 1.322.652 1.322 1.458z",
    stroke: "#353535",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181 197.616c0 .804-.593 1.458-1.322 1.458h-9.267c-.735 0-1.326-.654-1.326-1.458 0-.806.591-1.459 1.326-1.459h9.267c.73 0 1.322.653 1.322 1.459",
    fill: "#F4A27F",
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181 197.616c0 .804-.593 1.458-1.322 1.458h-9.267c-.735 0-1.326-.654-1.326-1.458 0-.806.591-1.459 1.326-1.459h9.267c.73 0 1.322.653 1.322 1.459z",
    stroke: "#353535",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.584 198.24c0 .807-.593 1.458-1.323 1.458h-9.27c-.725 0-1.322-.65-1.322-1.457 0-.806.597-1.458 1.322-1.458h9.27c.73 0 1.323.652 1.323 1.458",
    fill: "#666",
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.584 198.24c0 .807-.593 1.458-1.323 1.458h-9.27c-.725 0-1.322-.65-1.322-1.457 0-.806.597-1.458 1.322-1.458h9.27c.73 0 1.323.652 1.323 1.458z",
    stroke: "#353535",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.584 197.616c0 .804-.593 1.458-1.323 1.458h-9.27c-.725 0-1.322-.654-1.322-1.458 0-.806.597-1.459 1.322-1.459h9.27c.73 0 1.323.653 1.323 1.459",
    fill: "#F4A27F",
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.584 197.616c0 .804-.593 1.458-1.323 1.458h-9.27c-.725 0-1.322-.654-1.322-1.458 0-.806.597-1.459 1.322-1.459h9.27c.73 0 1.323.653 1.323 1.459z",
    stroke: "#353535",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.166 198.24c0 .807-.59 1.458-1.32 1.458h-9.267c-.735 0-1.328-.65-1.328-1.457 0-.806.593-1.458 1.328-1.458h9.266c.73 0 1.321.652 1.321 1.458",
    fill: "#41A9D8",
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.166 198.24c0 .807-.59 1.458-1.32 1.458h-9.267c-.735 0-1.328-.65-1.328-1.457 0-.806.593-1.458 1.328-1.458h9.266c.73 0 1.321.652 1.321 1.458z",
    stroke: "#368CB2",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.166 197.616c0 .804-.59 1.458-1.32 1.458h-9.267c-.735 0-1.328-.654-1.328-1.458 0-.806.593-1.459 1.328-1.459h9.266c.73 0 1.321.653 1.321 1.459",
    fill: "#41A9D8",
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.166 197.616c0 .804-.59 1.458-1.32 1.458h-9.267c-.735 0-1.328-.654-1.328-1.458 0-.806.593-1.459 1.328-1.459h9.266c.73 0 1.321.653 1.321 1.459z",
    stroke: "#368CB2",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.682 223.24c0 1.289-.81 2.33-1.803 2.33h-6.127c-.998 0-1.804-1.041-1.804-2.33v-4.203c0-1.29.806-2.336 1.804-2.336h6.127c.994 0 1.803 1.046 1.803 2.336v4.203z",
    fill: "#666",
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.682 223.24c0 1.289-.81 2.33-1.803 2.33h-6.127c-.998 0-1.804-1.041-1.804-2.33v-4.203c0-1.29.806-2.336 1.804-2.336h6.127c.994 0 1.803 1.046 1.803 2.336v4.203z",
    stroke: "#353535",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.201 223.032c0 1.164-.73 2.103-1.625 2.103h-5.526c-.895 0-1.62-.94-1.62-2.103v-3.786c0-1.163.725-2.105 1.62-2.105h5.526c.895 0 1.625.942 1.625 2.105v3.786z",
    fill: "#999",
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.201 223.032c0 1.164-.73 2.103-1.625 2.103h-5.526c-.895 0-1.62-.94-1.62-2.103v-3.786c0-1.163.725-2.105 1.62-2.105h5.526c.895 0 1.625.942 1.625 2.105v3.786z",
    stroke: "#353535",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.026 222.133c0 .99-.633 1.797-1.42 1.797h-4.84c-.788 0-1.426-.806-1.426-1.797v-3.23c0-.995.638-1.8 1.426-1.8h4.84c.787 0 1.42.805 1.42 1.8v3.23z",
    fill: "#999",
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.026 222.133c0 .99-.633 1.797-1.42 1.797h-4.84c-.788 0-1.426-.806-1.426-1.797v-3.23c0-.995.638-1.8 1.426-1.8h4.84c.787 0 1.42.805 1.42 1.8v3.23z",
    stroke: "#353535",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.44 223.24c0 1.289-.808 2.33-1.8 2.33h-6.132c-.992 0-1.799-1.041-1.799-2.33v-4.203c0-1.29.807-2.336 1.799-2.336h6.133c.991 0 1.798 1.046 1.798 2.336v4.203z",
    fill: "#666",
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.44 223.24c0 1.289-.808 2.33-1.8 2.33h-6.132c-.992 0-1.799-1.041-1.799-2.33v-4.203c0-1.29.807-2.336 1.799-2.336h6.133c.991 0 1.798 1.046 1.798 2.336v4.203z",
    stroke: "#353535",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.963 223.032c0 1.164-.73 2.103-1.63 2.103h-5.521c-.895 0-1.622-.94-1.622-2.103v-3.786c0-1.163.727-2.105 1.622-2.105h5.521c.9 0 1.63.942 1.63 2.105v3.786z",
    fill: "#666",
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.963 223.032c0 1.164-.73 2.103-1.63 2.103h-5.521c-.895 0-1.622-.94-1.622-2.103v-3.786c0-1.163.727-2.105 1.622-2.105h5.521c.9 0 1.63.942 1.63 2.105v3.786z",
    stroke: "#353535",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.787 222.133c0 .99-.636 1.797-1.421 1.797h-4.844c-.782 0-1.425-.806-1.425-1.797v-3.23c0-.995.643-1.8 1.425-1.8h4.844c.785 0 1.421.805 1.421 1.8v3.23z",
    fill: "#999",
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.787 222.133c0 .99-.636 1.797-1.421 1.797h-4.844c-.782 0-1.425-.806-1.425-1.797v-3.23c0-.995.643-1.8 1.425-1.8h4.844c.785 0 1.421.805 1.421 1.8v3.23z",
    stroke: "#353535",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.2 223.24c0 1.289-.805 2.33-1.799 2.33h-6.13c-.994 0-1.803-1.041-1.803-2.33v-4.203c0-1.29.809-2.336 1.803-2.336h6.13c.994 0 1.8 1.046 1.8 2.336v4.203z",
    fill: "#666",
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.2 223.24c0 1.289-.805 2.33-1.799 2.33h-6.13c-.994 0-1.803-1.041-1.803-2.33v-4.203c0-1.29.809-2.336 1.803-2.336h6.13c.994 0 1.8 1.046 1.8 2.336v4.203z",
    stroke: "#353535",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.72 223.032c0 1.164-.725 2.103-1.62 2.103h-5.526c-.897 0-1.625-.94-1.625-2.103v-3.786c0-1.163.728-2.105 1.625-2.105h5.525c.896 0 1.62.942 1.62 2.105v3.786z",
    fill: "#666",
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.72 223.032c0 1.164-.725 2.103-1.62 2.103h-5.526c-.897 0-1.625-.94-1.625-2.103v-3.786c0-1.163.728-2.105 1.625-2.105h5.525c.896 0 1.62.942 1.62 2.105v3.786z",
    stroke: "#353535",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.55 222.133c0 .99-.637 1.797-1.426 1.797h-4.84c-.788 0-1.425-.806-1.425-1.797v-3.23c0-.995.637-1.8 1.424-1.8h4.84c.79 0 1.426.805 1.426 1.8v3.23z",
    fill: "#999",
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.55 222.133c0 .99-.637 1.797-1.426 1.797h-4.84c-.788 0-1.425-.806-1.425-1.797v-3.23c0-.995.637-1.8 1.424-1.8h4.84c.79 0 1.426.805 1.426 1.8v3.23z",
    stroke: "#353535",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.682 233.95c0 1.29-.81 2.333-1.803 2.333h-6.127c-.998 0-1.804-1.042-1.804-2.333v-4.203c0-1.29.806-2.336 1.804-2.336h6.127c.994 0 1.803 1.045 1.803 2.336v4.203z",
    fill: "#999",
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.682 233.95c0 1.29-.81 2.333-1.803 2.333h-6.127c-.998 0-1.804-1.042-1.804-2.333v-4.203c0-1.29.806-2.336 1.804-2.336h6.127c.994 0 1.803 1.045 1.803 2.336v4.203z",
    stroke: "#353535",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.201 233.741c0 1.161-.73 2.105-1.625 2.105h-5.526c-.895 0-1.62-.944-1.62-2.105v-3.787c0-1.163.725-2.105 1.62-2.105h5.526c.895 0 1.625.942 1.625 2.105v3.787z",
    fill: "#666",
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.201 233.741c0 1.161-.73 2.105-1.625 2.105h-5.526c-.895 0-1.62-.944-1.62-2.105v-3.787c0-1.163.725-2.105 1.62-2.105h5.526c.895 0 1.625.942 1.625 2.105v3.787z",
    stroke: "#353535",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.026 232.844c0 .99-.633 1.796-1.42 1.796h-4.84c-.788 0-1.426-.807-1.426-1.796v-3.233c0-.996.638-1.798 1.426-1.798h4.84c.787 0 1.42.802 1.42 1.798v3.233z",
    fill: "#999",
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.026 232.844c0 .99-.633 1.796-1.42 1.796h-4.84c-.788 0-1.426-.807-1.426-1.796v-3.233c0-.996.638-1.798 1.426-1.798h4.84c.787 0 1.42.802 1.42 1.798v3.233z",
    stroke: "#353535",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.44 233.95c0 1.29-.808 2.333-1.8 2.333h-6.132c-.992 0-1.799-1.042-1.799-2.333v-4.203c0-1.29.807-2.336 1.799-2.336h6.133c.991 0 1.798 1.045 1.798 2.336v4.203z",
    fill: "#666",
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.44 233.95c0 1.29-.808 2.333-1.8 2.333h-6.132c-.992 0-1.799-1.042-1.799-2.333v-4.203c0-1.29.807-2.336 1.799-2.336h6.133c.991 0 1.798 1.045 1.798 2.336v4.203z",
    stroke: "#353535",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.963 233.741c0 1.161-.73 2.105-1.63 2.105h-5.521c-.895 0-1.622-.944-1.622-2.105v-3.787c0-1.163.727-2.105 1.622-2.105h5.521c.9 0 1.63.942 1.63 2.105v3.787z",
    fill: "#999",
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.963 233.741c0 1.161-.73 2.105-1.63 2.105h-5.521c-.895 0-1.622-.944-1.622-2.105v-3.787c0-1.163.727-2.105 1.622-2.105h5.521c.9 0 1.63.942 1.63 2.105v3.787z",
    stroke: "#353535",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.787 232.844c0 .99-.636 1.796-1.421 1.796h-4.844c-.782 0-1.425-.807-1.425-1.796v-3.233c0-.996.643-1.798 1.425-1.798h4.844c.785 0 1.421.802 1.421 1.798v3.233z",
    fill: "#999",
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.787 232.844c0 .99-.636 1.796-1.421 1.796h-4.844c-.782 0-1.425-.807-1.425-1.796v-3.233c0-.996.643-1.798 1.425-1.798h4.844c.785 0 1.421.802 1.421 1.798v3.233z",
    stroke: "#353535",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.2 233.95c0 1.29-.805 2.333-1.799 2.333h-6.13c-.994 0-1.803-1.042-1.803-2.333v-4.203c0-1.29.809-2.336 1.803-2.336h6.13c.994 0 1.8 1.045 1.8 2.336v4.203z",
    fill: "#666",
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.2 233.95c0 1.29-.805 2.333-1.799 2.333h-6.13c-.994 0-1.803-1.042-1.803-2.333v-4.203c0-1.29.809-2.336 1.803-2.336h6.13c.994 0 1.8 1.045 1.8 2.336v4.203z",
    stroke: "#353535",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.72 233.741c0 1.161-.725 2.105-1.62 2.105h-5.526c-.897 0-1.625-.944-1.625-2.105v-3.787c0-1.163.728-2.105 1.625-2.105h5.525c.896 0 1.62.942 1.62 2.105v3.787z",
    fill: "#666",
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.72 233.741c0 1.161-.725 2.105-1.62 2.105h-5.526c-.897 0-1.625-.944-1.625-2.105v-3.787c0-1.163.728-2.105 1.625-2.105h5.525c.896 0 1.62.942 1.62 2.105v3.787z",
    stroke: "#353535",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.55 232.844c0 .99-.637 1.796-1.426 1.796h-4.84c-.788 0-1.425-.807-1.425-1.796v-3.233c0-.996.637-1.798 1.424-1.798h4.84c.79 0 1.426.802 1.426 1.798v3.233z",
    fill: "#999",
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.55 232.844c0 .99-.637 1.796-1.426 1.796h-4.84c-.788 0-1.425-.807-1.425-1.796v-3.233c0-.996.637-1.798 1.424-1.798h4.84c.79 0 1.426.802 1.426 1.798v3.233z",
    stroke: "#353535",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.682 244.66c0 1.286-.81 2.332-1.803 2.332h-6.127c-.998 0-1.804-1.046-1.804-2.332v-4.203c0-1.291.806-2.334 1.804-2.334h6.127c.994 0 1.803 1.043 1.803 2.334v4.203z",
    fill: "#999",
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.682 244.66c0 1.286-.81 2.332-1.803 2.332h-6.127c-.998 0-1.804-1.046-1.804-2.332v-4.203c0-1.291.806-2.334 1.804-2.334h6.127c.994 0 1.803 1.043 1.803 2.334v4.203z",
    stroke: "#353535",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.201 244.45c0 1.164-.73 2.104-1.625 2.104h-5.526c-.895 0-1.62-.94-1.62-2.103v-3.787c0-1.164.725-2.102 1.62-2.102h5.526c.895 0 1.625.938 1.625 2.102v3.787z",
    fill: "#999",
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.201 244.45c0 1.164-.73 2.104-1.625 2.104h-5.526c-.895 0-1.62-.94-1.62-2.103v-3.787c0-1.164.725-2.102 1.62-2.102h5.526c.895 0 1.625.938 1.625 2.102v3.787z",
    stroke: "#353535",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.026 243.55c0 .994-.633 1.798-1.42 1.798h-4.84c-.788 0-1.426-.804-1.426-1.798v-3.229c0-.993.638-1.796 1.426-1.796h4.84c.787 0 1.42.803 1.42 1.796v3.23z",
    fill: "#999",
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.026 243.55c0 .994-.633 1.798-1.42 1.798h-4.84c-.788 0-1.426-.804-1.426-1.798v-3.229c0-.993.638-1.796 1.426-1.796h4.84c.787 0 1.42.803 1.42 1.796v3.23z",
    stroke: "#353535",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.44 244.66c0 1.286-.808 2.332-1.8 2.332h-6.132c-.992 0-1.799-1.046-1.799-2.332v-4.203c0-1.291.807-2.334 1.799-2.334h6.133c.991 0 1.798 1.043 1.798 2.334v4.203z",
    fill: "#999",
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.44 244.66c0 1.286-.808 2.332-1.8 2.332h-6.132c-.992 0-1.799-1.046-1.799-2.332v-4.203c0-1.291.807-2.334 1.799-2.334h6.133c.991 0 1.798 1.043 1.798 2.334v4.203z",
    stroke: "#353535",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.963 244.45c0 1.164-.73 2.104-1.63 2.104h-5.521c-.895 0-1.622-.94-1.622-2.103v-3.787c0-1.164.727-2.102 1.622-2.102h5.521c.9 0 1.63.938 1.63 2.102v3.787z",
    fill: "#999",
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.963 244.45c0 1.164-.73 2.104-1.63 2.104h-5.521c-.895 0-1.622-.94-1.622-2.103v-3.787c0-1.164.727-2.102 1.622-2.102h5.521c.9 0 1.63.938 1.63 2.102v3.787z",
    stroke: "#353535",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.787 243.55c0 .994-.636 1.798-1.421 1.798h-4.844c-.782 0-1.425-.804-1.425-1.798v-3.229c0-.993.643-1.796 1.425-1.796h4.844c.785 0 1.421.803 1.421 1.796v3.23z",
    fill: "#999",
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.787 243.55c0 .994-.636 1.798-1.421 1.798h-4.844c-.782 0-1.425-.804-1.425-1.798v-3.229c0-.993.643-1.796 1.425-1.796h4.844c.785 0 1.421.803 1.421 1.796v3.23z",
    stroke: "#353535",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.2 244.66c0 1.286-.805 2.332-1.799 2.332h-6.13c-.994 0-1.803-1.046-1.803-2.332v-4.203c0-1.291.809-2.334 1.803-2.334h6.13c.994 0 1.8 1.043 1.8 2.334v4.203z",
    fill: "#999",
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.2 244.66c0 1.286-.805 2.332-1.799 2.332h-6.13c-.994 0-1.803-1.046-1.803-2.332v-4.203c0-1.291.809-2.334 1.803-2.334h6.13c.994 0 1.8 1.043 1.8 2.334v4.203z",
    stroke: "#353535",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.72 244.45c0 1.164-.725 2.104-1.62 2.104h-5.526c-.897 0-1.625-.94-1.625-2.103v-3.787c0-1.164.728-2.102 1.625-2.102h5.525c.896 0 1.62.938 1.62 2.102v3.787z",
    fill: "#666",
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.72 244.45c0 1.164-.725 2.104-1.62 2.104h-5.526c-.897 0-1.625-.94-1.625-2.103v-3.787c0-1.164.728-2.102 1.625-2.102h5.525c.896 0 1.62.938 1.62 2.102v3.787z",
    stroke: "#353535",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.55 243.55c0 .994-.637 1.798-1.426 1.798h-4.84c-.788 0-1.425-.804-1.425-1.798v-3.229c0-.993.637-1.796 1.424-1.796h4.84c.79 0 1.426.803 1.426 1.796v3.23z",
    fill: "#999",
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.55 243.55c0 .994-.637 1.798-1.426 1.798h-4.84c-.788 0-1.425-.804-1.425-1.798v-3.229c0-.993.637-1.796 1.424-1.796h4.84c.79 0 1.426.803 1.426 1.796v3.23z",
    stroke: "#353535",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.682 255.368c0 1.29-.81 2.335-1.803 2.335h-6.127c-.998 0-1.804-1.045-1.804-2.335v-4.202c0-1.29.806-2.332 1.804-2.332h6.127c.994 0 1.803 1.043 1.803 2.332v4.202z",
    fill: "#999",
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.682 255.368c0 1.29-.81 2.335-1.803 2.335h-6.127c-.998 0-1.804-1.045-1.804-2.335v-4.202c0-1.29.806-2.332 1.804-2.332h6.127c.994 0 1.803 1.043 1.803 2.332v4.202z",
    stroke: "#353535",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.201 255.16c0 1.162-.73 2.104-1.625 2.104h-5.526c-.895 0-1.62-.942-1.62-2.104v-3.786c0-1.162.725-2.105 1.62-2.105h5.526c.895 0 1.625.943 1.625 2.105v3.786z",
    fill: "#999",
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.201 255.16c0 1.162-.73 2.104-1.625 2.104h-5.526c-.895 0-1.62-.942-1.62-2.104v-3.786c0-1.162.725-2.105 1.62-2.105h5.526c.895 0 1.625.943 1.625 2.105v3.786z",
    stroke: "#353535",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.026 254.263c0 .989-.633 1.799-1.42 1.799h-4.84c-.788 0-1.426-.81-1.426-1.799v-3.229c0-.996.638-1.802 1.426-1.802h4.84c.787 0 1.42.806 1.42 1.802v3.23z",
    fill: "#999",
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.026 254.263c0 .989-.633 1.799-1.42 1.799h-4.84c-.788 0-1.426-.81-1.426-1.799v-3.229c0-.996.638-1.802 1.426-1.802h4.84c.787 0 1.42.806 1.42 1.802v3.23z",
    stroke: "#353535",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.44 255.368c0 1.29-.808 2.335-1.8 2.335h-6.132c-.992 0-1.799-1.045-1.799-2.335v-4.202c0-1.29.807-2.332 1.799-2.332h6.133c.991 0 1.798 1.043 1.798 2.332v4.202z",
    fill: "#999",
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.44 255.368c0 1.29-.808 2.335-1.8 2.335h-6.132c-.992 0-1.799-1.045-1.799-2.335v-4.202c0-1.29.807-2.332 1.799-2.332h6.133c.991 0 1.798 1.043 1.798 2.332v4.202z",
    stroke: "#353535",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.963 255.16c0 1.162-.73 2.104-1.63 2.104h-5.521c-.895 0-1.622-.942-1.622-2.104v-3.786c0-1.162.727-2.105 1.622-2.105h5.521c.9 0 1.63.943 1.63 2.105v3.786z",
    fill: "#999",
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.963 255.16c0 1.162-.73 2.104-1.63 2.104h-5.521c-.895 0-1.622-.942-1.622-2.104v-3.786c0-1.162.727-2.105 1.622-2.105h5.521c.9 0 1.63.943 1.63 2.105v3.786z",
    stroke: "#353535",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.787 254.263c0 .989-.636 1.799-1.421 1.799h-4.844c-.782 0-1.425-.81-1.425-1.799v-3.229c0-.996.643-1.802 1.425-1.802h4.844c.785 0 1.421.806 1.421 1.802v3.23z",
    fill: "#999",
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.787 254.263c0 .989-.636 1.799-1.421 1.799h-4.844c-.782 0-1.425-.81-1.425-1.799v-3.229c0-.996.643-1.802 1.425-1.802h4.844c.785 0 1.421.806 1.421 1.802v3.23z",
    stroke: "#353535",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.2 255.368c0 1.29-.805 2.335-1.799 2.335h-6.13c-.994 0-1.803-1.045-1.803-2.335v-4.202c0-1.29.809-2.332 1.803-2.332h6.13c.994 0 1.8 1.043 1.8 2.332v4.202z",
    fill: "#999",
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.2 255.368c0 1.29-.805 2.335-1.799 2.335h-6.13c-.994 0-1.803-1.045-1.803-2.335v-4.202c0-1.29.809-2.332 1.803-2.332h6.13c.994 0 1.8 1.043 1.8 2.332v4.202z",
    stroke: "#353535",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.72 255.16c0 1.162-.725 2.104-1.62 2.104h-5.526c-.897 0-1.625-.942-1.625-2.104v-3.786c0-1.162.728-2.105 1.625-2.105h5.525c.896 0 1.62.943 1.62 2.105v3.786z",
    fill: "#999",
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.72 255.16c0 1.162-.725 2.104-1.62 2.104h-5.526c-.897 0-1.625-.942-1.625-2.104v-3.786c0-1.162.728-2.105 1.625-2.105h5.525c.896 0 1.62.943 1.62 2.105v3.786z",
    stroke: "#353535",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.55 254.263c0 .989-.637 1.799-1.426 1.799h-4.84c-.788 0-1.425-.81-1.425-1.799v-3.229c0-.996.637-1.802 1.424-1.802h4.84c.79 0 1.426.806 1.426 1.802v3.23z",
    fill: "#999",
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.55 254.263c0 .989-.637 1.799-1.426 1.799h-4.84c-.788 0-1.425-.81-1.425-1.799v-3.229c0-.996.637-1.802 1.424-1.802h4.84c.79 0 1.426.806 1.426 1.802v3.23z",
    stroke: "#353535",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.29 223.24c0 1.289-.806 2.33-1.8 2.33h-18.702c-.993 0-1.798-1.041-1.798-2.33v-4.203c0-1.29.805-2.336 1.798-2.336h18.703c.993 0 1.8 1.046 1.8 2.336v4.203z",
    fill: "#41A9D8",
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.29 223.24c0 1.289-.806 2.33-1.8 2.33h-18.702c-.993 0-1.798-1.041-1.798-2.33v-4.203c0-1.29.805-2.336 1.798-2.336h18.703c.993 0 1.8 1.046 1.8 2.336v4.203z",
    stroke: "#368CB2",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.812 223.032c0 1.164-.73 2.103-1.63 2.103h-18.087c-.898 0-1.625-.94-1.625-2.103v-3.786c0-1.163.727-2.105 1.625-2.105h18.087c.9 0 1.63.942 1.63 2.105v3.786z",
    fill: "#41A9D8",
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.812 223.032c0 1.164-.73 2.103-1.63 2.103h-18.087c-.898 0-1.625-.94-1.625-2.103v-3.786c0-1.163.727-2.105 1.625-2.105h18.087c.9 0 1.63.942 1.63 2.105v3.786z",
    stroke: "#368CB2",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.642 222.133c0 .99-.642 1.797-1.426 1.797h-17.414c-.783 0-1.426-.806-1.426-1.797v-3.23c0-.995.643-1.8 1.426-1.8h17.414c.784 0 1.426.805 1.426 1.8v3.23z",
    fill: "#41A9D8",
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.642 222.133c0 .99-.642 1.797-1.426 1.797h-17.414c-.783 0-1.426-.806-1.426-1.797v-3.23c0-.995.643-1.8 1.426-1.8h17.414c.784 0 1.426.805 1.426 1.8v3.23z",
    stroke: "#368CB2",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.29 255.281c0 1.289-.806 2.332-1.8 2.332h-18.702c-.993 0-1.798-1.043-1.798-2.332v-4.203c0-1.287.805-2.334 1.798-2.334h18.703c.993 0 1.8 1.047 1.8 2.334v4.203z",
    fill: "#41A9D8",
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.29 255.281c0 1.289-.806 2.332-1.8 2.332h-18.702c-.993 0-1.798-1.043-1.798-2.332v-4.203c0-1.287.805-2.334 1.798-2.334h18.703c.993 0 1.8 1.047 1.8 2.334v4.203z",
    stroke: "#368CB2",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.812 255.073c0 1.164-.73 2.106-1.63 2.106h-18.087c-.898 0-1.625-.942-1.625-2.106v-3.788c0-1.16.727-2.102 1.625-2.102h18.087c.9 0 1.63.942 1.63 2.102v3.788z",
    fill: "#41A9D8",
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.812 255.073c0 1.164-.73 2.106-1.63 2.106h-18.087c-.898 0-1.625-.942-1.625-2.106v-3.788c0-1.16.727-2.102 1.625-2.102h18.087c.9 0 1.63.942 1.63 2.102v3.788z",
    stroke: "#368CB2",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.642 254.177c0 .988-.642 1.792-1.426 1.792h-17.414c-.783 0-1.426-.804-1.426-1.792v-3.237c0-.99.643-1.795 1.426-1.795h17.414c.784 0 1.426.804 1.426 1.795v3.237z",
    fill: "#41A9D8",
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.642 254.177c0 .988-.642 1.792-1.426 1.792h-17.414c-.783 0-1.426-.804-1.426-1.792v-3.237c0-.99.643-1.795 1.426-1.795h17.414c.784 0 1.426.804 1.426 1.795v3.237z",
    stroke: "#368CB2",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.72 244.487c0 1.288-.807 2.337-1.8 2.337h-6.132c-.993 0-1.798-1.049-1.798-2.337v-14.74c0-1.29.805-2.336 1.798-2.336h6.132c.993 0 1.8 1.045 1.8 2.336v14.74z",
    fill: "#41A9D8",
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.72 244.487c0 1.288-.807 2.337-1.8 2.337h-6.132c-.993 0-1.798-1.049-1.798-2.337v-14.74c0-1.29.805-2.336 1.798-2.336h6.132c.993 0 1.8 1.045 1.8 2.336v14.74z",
    stroke: "#368CB2",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.238 244.281c0 1.163-.727 2.105-1.621 2.105h-5.52c-.9 0-1.627-.942-1.627-2.105v-14.327c0-1.163.727-2.105 1.626-2.105h5.521c.894 0 1.621.942 1.621 2.105v14.327z",
    fill: "#41A9D8",
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.238 244.281c0 1.163-.727 2.105-1.621 2.105h-5.52c-.9 0-1.627-.942-1.627-2.105v-14.327c0-1.163.727-2.105 1.626-2.105h5.521c.894 0 1.621.942 1.621 2.105v14.327z",
    stroke: "#368CB2",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.067 243.38c0 .992-.636 1.797-1.42 1.797h-4.845c-.783 0-1.425-.805-1.425-1.797v-13.769c0-.996.642-1.798 1.425-1.798h4.845c.784 0 1.42.802 1.42 1.798v13.769z",
    fill: "#41A9D8",
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.067 243.38c0 .992-.636 1.797-1.42 1.797h-4.845c-.783 0-1.425-.805-1.425-1.797v-13.769c0-.996.642-1.798 1.425-1.798h4.845c.784 0 1.42.802 1.42 1.798v13.769z",
    stroke: "#368CB2",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.479 233.95c0 1.29-.805 2.333-1.802 2.333h-6.127c-.994 0-1.8-1.042-1.8-2.333v-4.203c0-1.29.806-2.336 1.8-2.336h6.127c.997 0 1.802 1.045 1.802 2.336v4.203z",
    fill: "#41A9D8",
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.479 233.95c0 1.29-.805 2.333-1.802 2.333h-6.127c-.994 0-1.8-1.042-1.8-2.333v-4.203c0-1.29.806-2.336 1.8-2.336h6.127c.997 0 1.802 1.045 1.802 2.336v4.203z",
    stroke: "#368CB2",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226 233.741c0 1.161-.726 2.105-1.626 2.105h-5.522c-.894 0-1.624-.944-1.624-2.105v-3.787c0-1.163.73-2.105 1.624-2.105h5.522c.9 0 1.625.942 1.625 2.105v3.787z",
    fill: "#41A9D8",
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226 233.741c0 1.161-.726 2.105-1.626 2.105h-5.522c-.894 0-1.624-.944-1.624-2.105v-3.787c0-1.163.73-2.105 1.624-2.105h5.522c.9 0 1.625.942 1.625 2.105v3.787z",
    stroke: "#368CB2",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.828 232.844c0 .99-.636 1.796-1.425 1.796h-4.84c-.787 0-1.425-.807-1.425-1.796v-3.233c0-.996.638-1.798 1.426-1.798h4.839c.79 0 1.425.802 1.425 1.798v3.233z",
    fill: "#41A9D8",
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.828 232.844c0 .99-.636 1.796-1.425 1.796h-4.84c-.787 0-1.425-.807-1.425-1.796v-3.233c0-.996.638-1.798 1.426-1.798h4.839c.79 0 1.425.802 1.425 1.798v3.233z",
    stroke: "#368CB2",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.479 244.66c0 1.286-.805 2.332-1.802 2.332h-6.127c-.994 0-1.8-1.046-1.8-2.332v-4.203c0-1.291.806-2.334 1.8-2.334h6.127c.997 0 1.802 1.043 1.802 2.334v4.203z",
    fill: "#41A9D8",
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.479 244.66c0 1.286-.805 2.332-1.802 2.332h-6.127c-.994 0-1.8-1.046-1.8-2.332v-4.203c0-1.291.806-2.334 1.8-2.334h6.127c.997 0 1.802 1.043 1.802 2.334v4.203z",
    stroke: "#368CB2",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226 244.45c0 1.164-.726 2.104-1.626 2.104h-5.522c-.894 0-1.624-.94-1.624-2.103v-3.787c0-1.164.73-2.102 1.624-2.102h5.522c.9 0 1.625.938 1.625 2.102v3.787z",
    fill: "#41A9D8",
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226 244.45c0 1.164-.726 2.104-1.626 2.104h-5.522c-.894 0-1.624-.94-1.624-2.103v-3.787c0-1.164.73-2.102 1.624-2.102h5.522c.9 0 1.625.938 1.625 2.102v3.787z",
    stroke: "#368CB2",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.828 243.55c0 .994-.636 1.798-1.425 1.798h-4.84c-.787 0-1.425-.804-1.425-1.798v-3.229c0-.993.638-1.796 1.426-1.796h4.839c.79 0 1.425.803 1.425 1.796v3.23z",
    fill: "#41A9D8",
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.828 243.55c0 .994-.636 1.798-1.425 1.798h-4.84c-.787 0-1.425-.804-1.425-1.798v-3.229c0-.993.638-1.796 1.426-1.796h4.839c.79 0 1.425.803 1.425 1.796v3.23z",
    stroke: "#368CB2",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.524 257.154c0 .488-.143.881-.325.881-.174 0-.316-.393-.316-.881v-39.31c0-.489.142-.884.316-.884.182 0 .325.395.325.883v39.31z",
    fill: "#41A9D8",
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.524 257.154c0 .488-.143.881-.325.881-.174 0-.316-.393-.316-.881v-39.31c0-.489.142-.884.316-.884.182 0 .325.395.325.883v39.31z",
    stroke: "#353535",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.653 257.154c0 .488-.143.881-.316.881-.178 0-.325-.393-.325-.881v-39.31c0-.489.147-.884.325-.884.173 0 .316.395.316.883v39.31z",
    fill: "#41A9D8",
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.653 257.154c0 .488-.143.881-.316.881-.178 0-.325-.393-.325-.881v-39.31c0-.489.147-.884.325-.884.173 0 .316.395.316.883v39.31z",
    stroke: "#353535",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.699 229.62c0 6.507-5.276 11.788-11.786 11.788s-11.787-5.28-11.787-11.788c0-6.516 5.276-11.795 11.787-11.795 6.51 0 11.786 5.279 11.786 11.795",
    fill: "#41A9D8",
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.699 229.62c0 6.507-5.276 11.788-11.786 11.788s-11.787-5.28-11.787-11.788c0-6.516 5.276-11.795 11.787-11.795 6.51 0 11.786 5.279 11.786 11.795z",
    stroke: "#353535",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.699 229.007c0 6.51-5.276 11.79-11.786 11.79s-11.787-5.28-11.787-11.79c0-6.512 5.276-11.79 11.787-11.79 6.51 0 11.786 5.278 11.786 11.79",
    fill: "#41A9D8",
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.699 229.007c0 6.51-5.276 11.79-11.786 11.79s-11.787-5.28-11.787-11.79c0-6.512 5.276-11.79 11.787-11.79 6.51 0 11.786 5.278 11.786 11.79z",
    stroke: "#368CB2",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.699 229.007c0 6.51-5.276 11.79-11.786 11.79s-11.787-5.28-11.787-11.79c0-6.512 5.276-11.79 11.787-11.79 6.51 0 11.786 5.278 11.786 11.79",
    fill: "#666",
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.699 229.007c0 6.51-5.276 11.79-11.786 11.79s-11.787-5.28-11.787-11.79c0-6.512 5.276-11.79 11.787-11.79 6.51 0 11.786 5.278 11.786 11.79z",
    stroke: "#353535",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#41A9D8",
    mask: "url(#contact-graphic_svg__aX)",
    d: "M173.47 237.026l.34.34 16.042-16.046-.343-.343z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#353535",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__aX)",
    d: "M173.47 237.026l.34.34 16.042-16.046-.343-.343z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#41A9D8",
    mask: "url(#contact-graphic_svg__aX)",
    d: "M173.81 220.979l-.34.34 16.038 16.047.34-.34z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#353535",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__aX)",
    d: "M173.81 220.979l-.34.34 16.038 16.047.34-.34z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.858 229.007a5.947 5.947 0 01-5.945 5.947 5.948 5.948 0 01-5.945-5.947 5.948 5.948 0 015.945-5.946 5.947 5.947 0 015.945 5.946",
    fill: "#999",
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.858 229.007a5.947 5.947 0 01-5.945 5.947 5.948 5.948 0 01-5.945-5.947 5.948 5.948 0 015.945-5.946 5.947 5.947 0 015.945 5.946z",
    stroke: "#353535",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.527 229.007a5.616 5.616 0 11-11.23 0 5.62 5.62 0 015.616-5.619 5.617 5.617 0 015.614 5.619",
    fill: "#999",
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.527 229.007a5.616 5.616 0 11-11.23 0 5.62 5.62 0 015.616-5.619 5.617 5.617 0 015.614 5.619z",
    stroke: "#353535",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.376 251.043c0 .804-.592 1.455-1.326 1.455h-6.19c-.734 0-1.327-.651-1.327-1.455 0-.805.593-1.46 1.327-1.46h6.19c.734 0 1.326.655 1.326 1.46",
    fill: "#41A9D8",
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.376 251.043c0 .804-.592 1.455-1.326 1.455h-6.19c-.734 0-1.327-.651-1.327-1.455 0-.805.593-1.46 1.327-1.46h6.19c.734 0 1.326.655 1.326 1.46z",
    stroke: "#353535",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.376 250.419c0 .804-.592 1.456-1.326 1.456h-6.19c-.734 0-1.327-.652-1.327-1.456 0-.804.593-1.46 1.327-1.46h6.19c.734 0 1.326.656 1.326 1.46",
    fill: "#999",
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.376 250.419c0 .804-.592 1.456-1.326 1.456h-6.19c-.734 0-1.327-.652-1.327-1.456 0-.804.593-1.46 1.327-1.46h6.19c.734 0 1.326.656 1.326 1.46z",
    stroke: "#353535",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.292 251.043c0 .804-.596 1.455-1.326 1.455h-6.19c-.735 0-1.327-.651-1.327-1.455 0-.805.592-1.46 1.327-1.46h6.19c.73 0 1.326.655 1.326 1.46",
    fill: "#41A9D8",
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.292 251.043c0 .804-.596 1.455-1.326 1.455h-6.19c-.735 0-1.327-.651-1.327-1.455 0-.805.592-1.46 1.327-1.46h6.19c.73 0 1.326.655 1.326 1.46z",
    stroke: "#353535",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.292 250.419c0 .804-.596 1.456-1.326 1.456h-6.19c-.735 0-1.327-.652-1.327-1.456 0-.804.592-1.46 1.327-1.46h6.19c.73 0 1.326.656 1.326 1.46",
    fill: "#999",
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.292 250.419c0 .804-.596 1.456-1.326 1.456h-6.19c-.735 0-1.327-.652-1.327-1.456 0-.804.592-1.46 1.327-1.46h6.19c.73 0 1.326.656 1.326 1.46z",
    stroke: "#353535",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.858 272.225c3.737-10.207 4.64-20.797 4.699-21.566l-3.063-.241c-.014.186-.981 11.547-4.931 21.807h3.295z",
    fill: "#666",
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.858 272.225c3.737-10.207 4.64-20.797 4.699-21.566l-3.063-.241c-.014.186-.981 11.547-4.931 21.807h3.295z",
    stroke: "#353535",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.793 271.191c3.166-7.605 4.493-15.421 4.955-18.921-.837 4.889-2.43 12.085-5.259 18.921h.304z",
    fill: "#666",
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.793 271.191c3.166-7.605 4.493-15.421 4.955-18.921-.837 4.889-2.43 12.085-5.259 18.921h.304z",
    stroke: "#353535",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EF9673",
    mask: "url(#contact-graphic_svg__aX)",
    d: "M199.126 282.83H477.56V121.946H199.126z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#353535",
    strokeWidth: 2,
    strokeLinejoin: "round",
    mask: "url(#contact-graphic_svg__aX)",
    d: "M199.126 282.83H477.56V121.946H199.126z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.093 122.053h278.532l-34.812-29.702-24.42-20.84c-2.874-2.437-6.63-5.652-10.398-8.868l-32.51-27.727-26.728-22.813c-5.719-4.874-15.081-4.874-20.79 0L301.23 34.916l-32.509 27.727a7916.68 7916.68 0 01-10.391 8.868l-24.421 20.84-34.817 29.702z",
    fill: "#EF9673",
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.093 122.053h278.532l-34.812-29.702-24.42-20.84c-2.874-2.437-6.63-5.652-10.398-8.868l-32.51-27.727-26.728-22.813c-5.719-4.874-15.081-4.874-20.79 0L301.23 34.916l-32.509 27.727a7916.68 7916.68 0 01-10.391 8.868l-24.421 20.84-34.817 29.702z",
    stroke: "#353535",
    strokeWidth: 2,
    strokeLinejoin: "round",
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    mask: "url(#contact-graphic_svg__aX)",
    d: "M215.926 242.301H459.34V29.571H215.926z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#353535",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__aX)",
    d: "M215.926 242.301H459.34V29.571H215.926z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.436 122.256l-34.631 29.547-24.421 20.84c-2.865 2.433-6.628 5.65-10.393 8.867l-24.32 20.752h-90.628l-24.32-20.752a3983.743 3983.743 0 00-10.397-8.866l-24.416-20.841-34.635-29.547h-.149v160.572h278.683V122.256h-.373z",
    fill: "#EE4900",
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.436 122.256l-34.631 29.547-24.421 20.84c-2.865 2.433-6.628 5.65-10.393 8.867l-24.32 20.752h-90.628l-24.32-20.752a3983.743 3983.743 0 00-10.397-8.866l-24.416-20.841-34.635-29.547h-.149v160.572h278.683V122.256h-.373z",
    stroke: "#353535",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__aX)"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#contact-graphic_svg__aX)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M233.91 251.697l-34.784 31.099v.005l34.784-29.914 24.416-21.005c2.868-2.462 6.633-5.703 10.396-8.94l24.183-20.798",
    fill: "#C3E8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.91 251.697l-34.784 31.099v.005l34.784-29.914 24.416-21.005c2.868-2.462 6.633-5.703 10.396-8.94l24.183-20.798",
    stroke: "#353535",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#contact-graphic_svg__aX)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M383.808 202.143l24.184 20.798c3.765 3.238 7.527 6.48 10.39 8.941l24.423 21.005 34.82 29.94",
    fill: "#C3E8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.808 202.143l24.184 20.798c3.765 3.238 7.527 6.48 10.39 8.941l24.423 21.005 34.82 29.94",
    stroke: "#353535",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M75.61 60.621c0 7.853-6.367 14.218-14.219 14.218-7.854 0-14.221-6.365-14.221-14.218 0-7.854 6.367-14.22 14.221-14.22 7.852 0 14.22 6.366 14.22 14.22",
    fill: "#F4A27F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.61 60.621c0 7.853-6.367 14.218-14.219 14.218-7.854 0-14.221-6.365-14.221-14.218 0-7.854 6.367-14.22 14.221-14.22 7.852 0 14.22 6.366 14.22 14.22z",
    stroke: "#353535",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("mask", {
    id: "contact-graphic_svg__aZ",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#contact-graphic_svg__aY"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M58.776 68.595h3.557v-3.491h-3.557v3.49zm-3.648-10.969c.07-3.24 2.176-5.595 5.506-5.595 4.26 0 5.642 2.65 5.642 4.373 0 4.327-3.738 3.738-4.124 6.48v.862h-3.058v-1.022c.316-3.918 3.694-3.554 3.624-6.004 0-1.381-.724-2.039-1.926-2.039-1.63 0-2.333 1.338-2.333 2.945h-3.331z",
    fill: "#FFF",
    mask: "url(#contact-graphic_svg__aZ)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5D1C2",
    mask: "url(#contact-graphic_svg__aZ)",
    d: "M223.811 64.612h109.204V49.224H223.811zM224.175 129.46h225.044V70.318H224.175zM340.38 64.612h108.839V49.224h-108.84z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4A27F",
    mask: "url(#contact-graphic_svg__aZ)",
    d: "M308.05 166.687h57.382V146.96h-57.381zM192.364 72.577h-41.58v29.527h25.983v7.832l7.832-7.832h7.765z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#353535",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__aZ)",
    d: "M192.364 72.577h-41.58v29.527h25.983v7.832l7.832-7.832h7.765z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#contact-graphic_svg__aZ)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#BAE5F8",
    d: "M158.317 84.046h26.514"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#353535",
    strokeWidth: 2,
    d: "M158.317 84.046h26.514"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#contact-graphic_svg__aZ)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#BAE5F8",
    d: "M158.317 91.564h26.514"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#353535",
    strokeWidth: 2,
    d: "M158.317 91.564h26.514"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#EE4900",
    mask: "url(#contact-graphic_svg__aZ)",
    d: "M167.672 54.795h-65.544v31.379h12.238l12.349 12.349V86.174h40.957z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#353535",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__aZ)",
    d: "M167.672 54.795h-65.544v31.379h12.238l12.349 12.349V86.174h40.957z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#contact-graphic_svg__aZ)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#BAE5F8",
    d: "M113.135 67.425h43.53"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#353535",
    strokeWidth: 2,
    d: "M113.135 67.425h43.53"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#contact-graphic_svg__aZ)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#BAE5F8",
    d: "M113.135 74.944h43.53"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#353535",
    strokeWidth: 2,
    d: "M113.135 74.944h43.53"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    mask: "url(#contact-graphic_svg__aZ)",
    d: "M572.361 25.81L634.812.792 586.24 27.284z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#353535",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#contact-graphic_svg__aZ)",
    d: "M572.361 25.81L634.812.792 586.24 27.284z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    mask: "url(#contact-graphic_svg__aZ)",
    d: "M590.656 39.27L634.813.79l-48.574 26.494z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#353535",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#contact-graphic_svg__aZ)",
    d: "M590.656 39.27L634.813.79l-48.574 26.494z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    mask: "url(#contact-graphic_svg__aZ)",
    d: "M572.361 25.81l27.41-5.93-13.532 7.404z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#353535",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#contact-graphic_svg__aZ)",
    d: "M572.361 25.81l27.41-5.93-13.532 7.404z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    mask: "url(#contact-graphic_svg__aZ)",
    d: "M590.656 39.27l10.515-9.645-.7-10.094-14.232 7.753z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#353535",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#contact-graphic_svg__aZ)",
    d: "M590.656 39.27l10.515-9.645-.7-10.094-14.232 7.753z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    mask: "url(#contact-graphic_svg__aZ)",
    d: "M590.656 39.27L634.813.79l-38.48 29.017z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#353535",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#contact-graphic_svg__aZ)",
    d: "M590.656 39.27L634.813.79l-38.48 29.017z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    mask: "url(#contact-graphic_svg__aZ)",
    d: "M615.888 44.316L634.812.79l-38.48 29.017z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#353535",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#contact-graphic_svg__aZ)",
    d: "M615.888 44.316L634.812.79l-38.48 29.017z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    mask: "url(#contact-graphic_svg__aZ)",
    d: "M615.888 44.316L605.373 23.09l-9.04 6.717z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#353535",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#contact-graphic_svg__aZ)",
    d: "M615.888 44.316L605.373 23.09l-9.04 6.717z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.085 127.972c-8.906 0-16.125 7.22-16.125 16.124 0 8.906 7.22 16.124 16.125 16.124 8.904 0 16.123-7.218 16.123-16.124 0-8.905-7.22-16.124-16.123-16.124",
    fill: "#EE4900",
    mask: "url(#contact-graphic_svg__aZ)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.085 127.972c-8.906 0-16.125 7.22-16.125 16.124 0 8.906 7.22 16.124 16.125 16.124 8.904 0 16.123-7.218 16.123-16.124 0-8.905-7.22-16.124-16.123-16.124z",
    stroke: "#353535",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__aZ)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.862 67.04c-9.4 0-17.022 7.621-17.022 17.022 0 9.402 7.621 17.022 17.022 17.022 9.4 0 17.022-7.62 17.022-17.022 0-9.4-7.621-17.022-17.022-17.022",
    fill: "#F4A27F",
    mask: "url(#contact-graphic_svg__aZ)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.862 67.04c-9.4 0-17.022 7.621-17.022 17.022 0 9.402 7.621 17.022 17.022 17.022 9.4 0 17.022-7.62 17.022-17.022 0-9.4-7.621-17.022-17.022-17.022z",
    stroke: "#353535",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__aZ)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.627 76.25c0 .572-.215 1.06-.65 1.464a2.208 2.208 0 01-1.565.605c-.613 0-1.135-.2-1.575-.605-.438-.404-.656-.892-.656-1.465 0-.574.218-1.066.656-1.473a2.23 2.23 0 011.575-.61c.61 0 1.132.203 1.564.61.436.407.651.9.651 1.473m-.238 13.812l-.247 1.022c-.749.295-1.343.517-1.788.67-.445.156-.962.232-1.551.232-.904 0-1.608-.22-2.11-.66a2.142 2.142 0 01-.752-1.68c0-.267.019-.535.055-.811.039-.275.099-.586.184-.933l.934-3.305c.084-.316.152-.617.21-.898.055-.285.082-.541.082-.773 0-.423-.083-.717-.258-.887-.177-.162-.508-.247-1-.247-.242 0-.488.038-.742.112-.254.075-.473.15-.652.218l.246-1.019a21.697 21.697 0 011.76-.638 5.206 5.206 0 011.584-.267c.898 0 1.592.216 2.079.652.487.432.73.996.73 1.69 0 .14-.016.395-.051.758-.034.36-.097.692-.189.996l-.928 3.292a9.389 9.389 0 00-.204.905c-.06.341-.092.595-.092.77 0 .436.098.736.296.892.194.161.532.239 1.013.239.229 0 .483-.04.772-.12.284-.077.49-.15.619-.21",
    fill: "#FFF",
    mask: "url(#contact-graphic_svg__aZ)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.365 43.047c-10.556 9.147-39.903 26.215-73.525 18.906-24.158-5.252-33.61-27.309-18.41-30.327 20.367-4.045 24.352 28.958 2.876 55.171-8.567 10.458-24.728 19.586-43.258 25.655",
    stroke: "#EE4900",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "9.348000000000001,9.348000000000001",
    mask: "url(#contact-graphic_svg__aZ)"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#contact-graphic_svg__aZ)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F6FAFB",
    d: "M322.693 156.928h28.097"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#999",
    strokeWidth: 2,
    d: "M322.693 156.928h28.097"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#contact-graphic_svg__aZ)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F6FAFB",
    d: "M231.674 79.367h28.097"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#999",
    strokeWidth: 2,
    d: "M231.674 79.367h28.097"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#contact-graphic_svg__aZ)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F6FAFB",
    d: "M231.674 56.81h51.661"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#999",
    strokeWidth: 2,
    d: "M231.674 56.81h51.661"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#contact-graphic_svg__aZ)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F6FAFB",
    d: "M346.041 56.81h28.097"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#999",
    strokeWidth: 2,
    d: "M346.041 56.81h28.097"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M31.908 122.79a7.722 7.722 0 01-7.726-7.72c0-4.262 3.458-7.72 7.726-7.72a7.716 7.716 0 017.716 7.72 7.716 7.716 0 01-7.716 7.72m0-23.275c-8.596 0-15.557 6.965-15.557 15.554 0 8.595 15.557 21.858 15.557 21.858s15.554-13.263 15.554-21.858c0-8.59-6.962-15.554-15.554-15.554",
    fill: "#EE4900",
    mask: "url(#contact-graphic_svg__aZ)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.908 122.79a7.722 7.722 0 01-7.726-7.72c0-4.262 3.458-7.72 7.726-7.72a7.716 7.716 0 017.716 7.72 7.716 7.716 0 01-7.716 7.72zm0-23.275c-8.596 0-15.557 6.965-15.557 15.554 0 8.595 15.557 21.858 15.557 21.858s15.554-13.263 15.554-21.858c0-8.59-6.962-15.554-15.554-15.554z",
    stroke: "#353535",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__aZ)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.908 122.79a7.722 7.722 0 01-7.726-7.72c0-4.262 3.458-7.72 7.726-7.72a7.716 7.716 0 017.716 7.72 7.716 7.716 0 01-7.716 7.72",
    fill: "#FFF",
    mask: "url(#contact-graphic_svg__aZ)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.908 122.79a7.722 7.722 0 01-7.726-7.72c0-4.262 3.458-7.72 7.726-7.72a7.716 7.716 0 017.716 7.72 7.716 7.716 0 01-7.716 7.72z",
    stroke: "#353535",
    strokeWidth: 2,
    mask: "url(#contact-graphic_svg__aZ)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.988 146.815l-3.888 3.888c-.88.881-2.133 1.058-2.793.396-.664-.663-.487-1.914.394-2.795l3.888-3.888 2.4 2.399zM655.456 136.544l-1.321 1.32a1.127 1.127 0 11-1.595-1.595l1.32-1.32 1.596 1.595zM648.189 142.215l4.353-4.351",
    stroke: "#FFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#contact-graphic_svg__aZ)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.892 134.886l2.455 2.456-.546 2.04-2.04.545-2.455-2.455a4.417 4.417 0 001.01 4.674 4.412 4.412 0 004.213 1.153l7.873 7.874c.881.88 2.31.88 3.19 0a2.253 2.253 0 000-3.19l-7.874-7.874c.37-1.459-.01-3.07-1.153-4.212a4.417 4.417 0 00-4.673-1.011z",
    stroke: "#FFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#contact-graphic_svg__aZ)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.882 148.745a.66.66 0 10-.002 1.32.66.66 0 00.002-1.32z",
    stroke: "#FFF",
    mask: "url(#contact-graphic_svg__aZ)"
  })))));
}
export default SvgContactGraphic;